import { render, staticRenderFns } from "./AvLocalSummary.vue?vue&type=template&id=0564986c&lang=pug"
import script from "./AvLocalSummary.vue?vue&type=script&lang=ts"
export * from "./AvLocalSummary.vue?vue&type=script&lang=ts"
import style0 from "./AvLocalSummary.vue?vue&type=style&index=0&id=0564986c&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvSavings: require('/app/components/generic/AvSavings.vue').default})
